import PostApplicationSubmissionModule from './PostApplicationSubmission.module';

export default PostApplicationSubmissionModule;
